import {
  boxFromLine,
  isBoxLayout,
  isLineLayout,
  isPinComponentLocked,
  OnMouseDownHandler,
} from '@lessonup/pin-renderer';
import { isCategoryAreaPinComponent, PinComponent } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { BoxLayoutGrippies } from './BoxLayoutGrippies';
import { CategoryAreaControlBox } from './CategoryAreaControlBox';
import { LineLayoutGrippies } from './LineLayoutGrippies';

interface ActiveComponentBoxProps {
  active: PinComponent;
  scale: number;
  onMouseDown: OnMouseDownHandler;
  isPinComponentHighlighted: boolean;
  activeCategoryId?: string;
}

export const ActivePinComponentBox: React.FC<ActiveComponentBoxProps> = ({
  active,
  scale,
  onMouseDown,
  isPinComponentHighlighted,
  activeCategoryId,
}) => {
  const isCategoryArea = isCategoryAreaPinComponent(active);
  const showOutline = isBoxLayout(active.layout);
  const box = isLineLayout(active.layout) ? boxFromLine(active.layout) : active.layout;

  return (
    <StyledBox
      showOutline={showOutline}
      style={{
        width: box.size.width * scale,
        height: box.size.height * scale,
        transform: `translate(${box.position.x * scale}px, ${box.position.y * scale}px)  rotate(${box.rotation}deg)`,
      }}
    >
      {isBoxLayout(active.layout) && (
        <BoxLayoutGrippies
          active={active}
          onMouseDown={onMouseDown}
          isPinComponentHighlighted={isPinComponentHighlighted}
        />
      )}
      {!isPinComponentLocked(active) && isLineLayout(active.layout) && (
        <LineLayoutGrippies scale={scale} active={active} onMouseDown={onMouseDown} />
      )}

      {isCategoryArea && (
        <CategoryAreaControlBox
          active={active}
          scale={scale}
          onMouseDown={onMouseDown}
          isPinComponentHighlighted={isPinComponentHighlighted}
          activeCategoryId={activeCategoryId}
        />
      )}
    </StyledBox>
  );
};

const StyledBox = styled.div<{ showOutline: boolean }>`
  position: absolute;
`;
